import Button from '@atlaskit/button';
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';
import Textfield from '@atlaskit/textfield';
import React from 'react';
import { debounce } from 'throttle-debounce';

type DebouncedTextfieldProps = {
  onFilterChanged: (x: string) => void;
  placeholder: string;
  value: string | undefined;
  isDisabled?: boolean;
  testId?: string;
};
type DebouncedTextfieldState = {
  internalValue: string | undefined;
  debounce: any;
};
export class DebouncedTextfield extends React.Component<DebouncedTextfieldProps, DebouncedTextfieldState> {
  // https://www.peterbe.com/plog/how-to-throttle-and-debounce-an-autocomplete-input-in-react
  // https://github.com/niksy/throttle-debounce#readme
  state: DebouncedTextfieldState = {
    internalValue: this.props.value,
    debounce: debounce(500, this.props.onFilterChanged),
  };

  updateValue(v: string) {
    this.setState({
      internalValue: v,
    });
    this.state.debounce(v);
  }
  render() {
    return (
      <Textfield
        testId={this.props.testId}
        isDisabled={this.props.isDisabled === true}
        isCompact
        onChange={(e: any) => this.updateValue(e.target.value)}
        placeholder={this.props.placeholder}
        value={this.state.internalValue}
        elemAfterInput={
          <div
            style={{
              marginRight: '5px',
              marginTop: '0px',
              height: '28px',
              width: '26px',
              display: this.state.internalValue === '' ? 'none' : 'flex',
              alignItems: 'center',
            }}
          >
            <Button
              isDisabled={this.props.isDisabled === true}
              testId={`${this.props.testId}-clear`}
              onClick={() => this.updateValue('')}
              appearance="subtle"
              spacing="none"
              iconBefore={<EditorCloseIcon size="medium" label="close" primaryColor="#333" />}
            />
          </div>
        }
      />
    );
  }
}
